import {NciGroupTree} from '@features/nciAdministration/types';
import {PageSchema, ParamsType} from 'utils';
import api from 'utils/api';
import {PageData} from 'utils/hooks/useNewPageData';

const getNciGroupsTree = () => {
    return api.get<NciGroupTree>('/admin/dict/tree');
};

const getDictsTableSchema = (pathCode: string) => {
    return api.get<PageSchema>(`/table/schema/${pathCode}`);
};

const getNciGroupsTableData = <T>(findAllUrl: string, params: ParamsType) => {
    const url = (findAllUrl || '').replace('/api', '');
    return api.get<PageData<T>>(url, params);
};

const createNciDictUnit = (findAllUrl: string, data:unknown) => {
    const url = (findAllUrl || '').replace('/api', '');
    return api.post(url, data);
};
export const NciAdministrationService = {
    getNciGroupsTree,
    getDictsTableSchema,
    getNciGroupsTableData,
    createNciDictUnit,
};
